import axiosInstance from "../../axios/index";
import { alertSuccess } from "../../utils/feedback";
import { translate } from "../../utils/utils";

import {
  SELECT_USE_CASE,
  SET_ALL_USE_CASES,
  ADD_QUESTION_TO_USE_CASE,
  OPEN_DELETE_MODAL,
  CLOSE_DELETE_MODAL,
  INFINTIE_USECASES,
  SET_SEARCHED_USECASES,
} from "../types/usecaseTypes";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";

export const selectUseCase = (item) => ({
  type: SELECT_USE_CASE,
  payload: item,
});

export const setInfiniteUseCases = (items, totalPages) => ({
  type: INFINTIE_USECASES,
  payload: { items, totalPages },
});

export const setSearchedUseCases = (items, totalPages) => ({
  type: SET_SEARCHED_USECASES,
  payload: { items, totalPages },
});

export const setAllUseCases = (items, totalPages, sources, levels) => ({
  type: SET_ALL_USE_CASES,
  payload: { items, totalPages, sources, levels },
});

export const addQuestionToUseCase = (item) => ({
  type: ADD_QUESTION_TO_USE_CASE,
  payload: item,
});

export const openDeleteModal = () => ({ type: OPEN_DELETE_MODAL });

export const closeDeleteModal = () => ({ type: CLOSE_DELETE_MODAL });

export const fetchUseCaseById = (id) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.get(`/model/usecases/${id}`);
      dispatch(requestSucceeded());
      dispatch(closeDeleteModal());
      const item = res.data;
      dispatch(selectUseCase(item));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const fetchAllUseCase = (
  page,
  searchText,
  filter,
  difficultyLevel,
  infinite
) => {
  return async (dispatch) => {
    const token = localStorage.getItem("token");

    try {
      dispatch(requestStarted("useCase"));
      const res = token
        ? await axiosInstance.get(
            `/model/usecases?page=${page}&search${
              searchText ? "=" + searchText : ""
            }&source${filter !== "all" ? "=" + filter : ""}&level${
              difficultyLevel !== "all" ? "=" + difficultyLevel : ""
            }&ids`
          )
        : await axiosInstance.get(`/model/usecases_off`);
      if (token) {
        if (infinite) {
          if (searchText && page === 1) {
            console.log("searcgg", res.data?.usecases);
            dispatch(
              setSearchedUseCases(res.data?.usecases, res.data?.total_pages)
            );
          } else {
            dispatch(
              setInfiniteUseCases(res.data?.usecases, res.data?.total_pages)
            );
          }
        } else {
          dispatch(
            setAllUseCases(
              res.data?.usecases,
              res.data?.total_pages,
              res.data?.sources,
              res.data?.levels
            )
          );
        }
      } else {
        dispatch(setAllUseCases(res.data));
      }
      dispatch(requestSucceeded());
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestAddQuestionToUseCase = (data) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.post(`/model/questions`, {
        id_usecase: data?.id_usecase,
        question: {
          title: data.question.title,
          title_fr: data.question.title_fr,
          choices: data?.question?.choices?.map((el) => ({
            title: el.title,
            title_fr: el.title_fr,
            weight: el.weight,
          })),
        },
      });
      dispatch(fetchUseCaseById(data.id_usecase));
      if (res) {
        alertSuccess(res.data);
      }
      dispatch(requestSucceeded());
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestAddUseCase = (data, history, accountId, accountType) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const dataTitle = data.title;
      const dataDescription = data.description;
      delete data.title;
      delete data.description;
      if (accountType === "enterprise") {
        data.related_account_id = accountId;
      }
      const res = await axiosInstance.post(`model/usecases`, {
        ...data,
        [translate("title")]: dataTitle,
        [translate("description")]: dataDescription,
        duplication: false
      });
      dispatch(requestSucceeded(res.data.message));
      if (res) {
        alertSuccess(res.data);
      }
      history.push(`/make-usecase/${res.data.id_usecase}`);
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestDuplicateUseCase = (
  data,
  history,
  accountId,
  accountType
) => {
  return (dispatch) => {
    dispatch(requestStarted());
    const useCaseData = {
      title: `Copy of: ${data?.title}`,
      title_fr: `Copie de: ${data?.title_fr}`,
      description: `${data?.description}`,
      description_fr: `${data?.description_fr}`,
      difficulty_level: data.difficulty_level,
      idw: data?.weakness?.id,
      threshold: data?.threshold,
      uc_coefficient: data?.coefficient,
      duplication: true
    };
    if (accountType === "enterprise") {
      useCaseData.related_account_id = accountId;
    }
    axiosInstance
      .post(`model/usecases`, useCaseData)
      .then((res) => {
        const id = res?.data?.id_usecase;

        const questionPromises = data?.questions?.map(async (el) => {
          const questionData = {
            id_usecase: id,
            question: {
              title: el?.title,
              choices: el?.choices?.map((item) => ({
                title: item.title,
                weight: item.weight,
              })),
            },
          };
          if (accountType === "enterprise") {
            questionData.related_account_id = accountId;
          }
          await axiosInstance.post(`/model/questions`, questionData);
        });

        Promise.all(questionPromises)
          .then(() => {
            dispatch(fetchUseCaseById(id));
            history.push(`/make-usecase/${id}`, true);
            dispatch(requestSucceeded(res.data.message));
            if (res) {
              alertSuccess({
                message: "Use Case duplicated successfully!",
                message_fr: "Cas d'usage dupliqué avec succès",
              });
            }
          })
          .catch((error) => {
            dispatch(requestFailed(error?.response?.data));
          });
      })
      .catch((error) => {
        dispatch(requestFailed(error?.response?.data));
      });
  };
};

export const requestEditUseCase = (data, id, accountId, accountType) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const dataTitle = data.title;
      const dataDescription = data.description;
      delete data.title;
      delete data.description;
      if (accountType === "enterprise") {
        data.related_account_id = accountId;
      }

      const res = await axiosInstance.put(`model/usecases/${id}`, {
        ...data,
        [translate("title")]: dataTitle,
        [translate("description")]: dataDescription,
      });
      dispatch(requestSucceeded(res.data.message));
      dispatch(fetchUseCaseById(id));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestEditQuestion = (id_question, data, id_usecase) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const dataTitle = data.title;
      const dataDescription = data.description;
      delete data.title;
      delete data.description;
      await axiosInstance.put(`/model/questions/${id_question}`, {
        ...data,
        [translate("title")]: dataTitle,
        [translate("description")]: dataDescription,
      });
      dispatch(fetchUseCaseById(id_usecase));
      dispatch(requestSucceeded());
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestDeletingQuestion = (id_question, id_usecase) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.delete(
        `model/questions/${id_usecase}/${id_question}`
      );
      dispatch(requestSucceeded());
      dispatch(fetchUseCaseById(id_usecase));
      alertSuccess(res.data);
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const requestDeletingUseCase = (
  page,
  searchText,
  filter,
  difficultyLevel,
  id_usecase,
  accountId,
  accountType
) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res =
        accountType === "enterprise"
          ? await axiosInstance.delete(
              `model/usecases/${id_usecase}?related_account_id=${accountId}`
            )
          : await axiosInstance.delete(`model/usecases/${id_usecase}`);
      dispatch(requestSucceeded(res.data.message));
      if (res) {
        alertSuccess(res.data);
      }
      dispatch(fetchAllUseCase(page, searchText, filter, difficultyLevel));
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};
